import { Component, OnInit } from '@angular/core';
import { CommissionDetailsSearchHandler} from './commission-details-search.handler';

import { Router } from '@angular/router';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { CompensationService } from '../services/compensation.service';

@Component({
  selector: 'sym-commission-details-search',
  templateUrl: './commission-details-search.component.html',
  styleUrls: ['./commission-details-search.component.scss'],
})
export class CommissionDetailsSearchComponent extends CommissionDetailsSearchHandler {

  constructor( 
    public service: CompensationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ){
    super(service, headerService, router, settingService);
  }
  
  ngOnInit() {
  super.ngOnInit();
  }

}
